import { render } from "./TerminosYCondiciones.vue?vue&type=template&id=7e9d194d&scoped=true"
const script = {}

import "./TerminosYCondiciones.vue?vue&type=style&index=0&id=7e9d194d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e9d194d"]])

export default __exports__